import { NavigationExtras } from '@angular/router';
import { AlternativeBackButtonConfiguration } from './navigation.reducer';

import { createActionGroup, props } from '@ngrx/store';

export const navigationActions = createActionGroup({
  source: 'Router',
  events: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Go: props<{ path: any[]; query?: object; extras?: NavigationExtras; forceReload?: boolean }>(),
    Back: props<{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      path: any[];
      query?: object;
      extras?: NavigationExtras;
      forceReload?: boolean;
    }>(),
    Forward: props<{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      path: any[];
      query?: object;
      extras?: NavigationExtras;
      forceReload?: boolean;
    }>(),
    SetAlternativeBackNavigationButton: props<{
      alternativeBackButton: AlternativeBackButtonConfiguration;
    }>(),
  },
});
